import { render, staticRenderFns } from "./ClienteXUnidadeForm.vue?vue&type=template&id=43ce4b53"
import script from "./ClienteXUnidadeForm.vue?vue&type=script&lang=js"
export * from "./ClienteXUnidadeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports